import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const loginEmbedRoute: InvariantJiraRoute = {
	name: 'login-embed',
	path: '/jira-login/embed',
};
